import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem
} from "@mui/material";
import axios from "axios";

// 👉 MISMA BASE QUE USA TODA TU APP
const API = process.env.REACT_APP_API_URL;

// 👉 Convierte dd/mm/yyyy → yyyy-mm-dd
const toISODate = (d) => {
  if (!d || typeof d !== "string" || !d.includes("/")) return "";
  const [day, month, year] = d.split("/");
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};

// 👉 Normaliza género
const normalizeGenero = (g) => {
  if (!g) return "";
  const val = g.toLowerCase();
  if (val.includes("masc")) return "Masculino";
  if (val.includes("fem")) return "Femenino";
  return "";
};

export default function PasoValidacion({ data, update, next }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const buscarEmpleado = async () => {
    if (!data.tipoIdentidad) {
      setError("Debe seleccionar el tipo de identificación");
      return;
    }

    if (!data.numeroDocumento) {
      setError("Debe ingresar el número de identificación");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await axios.get(
        `${API}/api/affiliation/employees/${data.numeroDocumento}`
      );

      console.log("RESPUESTA AFILIACION:", res.data);

      // 👉 Si NO existe en employees → continuar flujo normal
      if (!res.data?.found) {
        update({
          datosAutocompletados: false
        });

        setLoading(false);
        return next();
      }
      const u = res.data.data;

      // 👉 Autocompletado desde employees
      update({
        datosAutocompletados: true,

        // 🔒 estos dos quedan definidos desde validación
        tipoIdentidad: data.tipoIdentidad,
        numeroDocumento: data.numeroDocumento,

        nombres: u.Nombres || "",
        fechaNacimiento: toISODate(u["Fecha Nacimiento"]),
        lugarNacimiento: u["Lugar Nacimiento"] || "",
        genero: normalizeGenero(u.Genero),
        direccion: u.Dirección || "",
        municipio: u.Municipio || "",
        telefonoFijo: u["Teléfono Fijo"] || "",
        celular: u.Celular || "",
        correoPersonal: u["Correo Personal"] || "",
        estrato: u.Estrato || "",
        estadoCivil: u["Estado Civil"] || "",
        salario: u.Salario || "",
      });

      setLoading(false);
      next();
    } catch (err) {
      console.error("❌ Error validando empleado:", err);
      setLoading(false);
      next(); // no bloqueamos el flujo
    }
  };

  const isNumeroDocumentoValido = (num) => {
    if (!num) return false;
    return /^\d{7,10}$/.test(num);
  };

  const canContinue =
    Boolean(data.tipoIdentidad) &&
    isNumeroDocumentoValido(data.numeroDocumento);

  return (
    <Box
      sx={{
        maxWidth: 420,
        mx: "auto",
      }}
    >
      {/* TÍTULO CENTRADO */}
      <Typography variant="h6" fontWeight={500} mb={3} textAlign="center">
        Validación de identidad
      </Typography>

      {/* CAMPOS A LA IZQUIERDA */}
      <Box sx={{ textAlign: "left" }}>
        <TextField
          select
          label="Tipo de identificación"
          fullWidth
          sx={{ mb: 2 }}
          value={data.tipoIdentidad || ""}
          onChange={(e) =>
            update({ tipoIdentidad: e.target.value })
          }
        >
          <MenuItem value="CC">Cédula de ciudadanía</MenuItem>
          <MenuItem value="CE">Cédula de extranjería</MenuItem>
          <MenuItem value="PA">Pasaporte</MenuItem>
        </TextField>

        <TextField
          label="Número de identificación"
          fullWidth
          value={data.numeroDocumento || ""}
          onChange={(e) => {
            // 🔒 solo números
            const value = e.target.value.replace(/\D/g, "");
            update({ numeroDocumento: value });
          }}
          error={
            Boolean(data.numeroDocumento) &&
            !isNumeroDocumentoValido(data.numeroDocumento)
          }
          helperText={
            Boolean(data.numeroDocumento) &&
              !isNumeroDocumentoValido(data.numeroDocumento)
              ? "Debe contener entre 7 y 10 dígitos"
              : ""
          }
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            minLength: 7,
            maxLength: 10
          }}
        />

      </Box>

      {error && (
        <Typography color="error" mt={1}>
          {error}
        </Typography>
      )}

      {/* BOTÓN CENTRADO */}
      <Box textAlign="center">
        <Button
          variant="contained"
          onClick={buscarEmpleado}
          disabled={!canContinue || loading}   // 👈 AQUÍ
          sx={{
            mt: 3,
            borderRadius: "20px",
            px: 4,
            textTransform: "none",
            fontSize: "1rem"
          }}
        >
          {loading ? "Consultando, por favor espere..." : "Continuar"}
        </Button>
      </Box>
    </Box>
  );
}
